// document.addEventListener('DOMContentLoaded', function () {
//     // console.log('>>>> scroll call');
//     // Ensure the script runs after the DOM is fully loaded
//     const popup = document.querySelector('.custom-price-popup-content');

//     if (!popup) {
//         console.warn('Element with class custom-price-popup-content not found.');
//         return;
//     }

//     window.addEventListener('scroll', function () {
//         const scrollTop = window.scrollY || document.documentElement.scrollTop;

//         if (scrollTop > 100) {
//             // console.log('>>>> Scrolled more than 100px');
//             $('.custom-price-popup-content').fadeOut();
//         }
//     });
// });

// Handle variant button click to update active state, image, price, and variant ID input
function handleOptioncardClick(button, optionName, optionValue, productId, variantId, variantImage, variantPrice, inventory_quantity, inventory_policy, dnkAtcTitle) {
    const buttons = document.querySelectorAll(`.variant-button-${productId}`);
    buttons.forEach(btn => btn.classList.remove('v_active'));

    // Add active class to the clicked button
    button.classList.add('v_active');

    // Update product thumbnail image with selected variant's image
    updateThumbnailImage(productId, variantImage);

    // Update the variant ID input for all sections with the same productId
    const variantInputs = document.querySelectorAll(`.max-parent-variant-${productId} .product-variant-id`);
    variantInputs.forEach(input => input.value = variantId);

    $(button).closest('.max-parent-variant')
        .siblings('.dev_atc_form')
        .find('.form')
        .find('.product-variant-id')
        .val(variantId);

    // Update the swatch title for the specific card
    $(button).closest('.max-parent-variant').find('.swatch-title-card').text(optionValue);

    // Update the price for the specific variant
    const moneyPrint = $(button).closest('.max-parent-variant').siblings('.money-div').find('.money-print');
    moneyPrint.html(`<span class="non-bold">₹</span>${variantPrice}`);

    // Change "Add to Cart" button text based on inventory quantity
    let customATCText = dnkAtcTitle; // Get metafield title if available
    let inventoryQuantity = parseInt(inventory_quantity, 10); // Convert to integer

    // Get the "Add to Cart" button
    let $cc = $(button).closest('.max-parent-variant').siblings('.dev_atc_form').find('.devx_add_to_cart_button');


    // Update "Add to Cart" button text and state
    if (inventoryQuantity > 0) {
        $cc.find('span:last').text('ADD TO CART');
        $cc.prop('disabled', false).removeAttr('disabled').attr('aria-disabled', 'false').removeClass('disabled');
    } else {
        // check continue salling
        if(inventory_policy == "continue"){
            $cc.find('span:last').text('ADD TO CART');
            $cc.prop('disabled', false).removeAttr('disabled').attr('aria-disabled', 'false').removeClass('disabled');
        }else{
            let atcText = dnkAtcTitle && dnkAtcTitle.trim() ? dnkAtcTitle : 'SOLD OUT';
            $cc.find('span:last').text(atcText);
            if (atcText === 'SOLD OUT') {
                $cc.prop('disabled', true).attr('disabled', 'disabled');
            } else {
                $cc.prop('disabled', false).removeAttr('disabled');
            }
        }
    }

    // Final debugging log
    // console.log("Disabled Attribute:", $cc.prop('disabled'));
}


// Update the thumbnail image of the product for all instances with the same productId
function updateThumbnailImage(productId, imageUrl) {
    const productThumbnails = document.querySelectorAll(`#product-image-${productId}`);
    productThumbnails.forEach(productThumbnail => {
        if (productThumbnail) {
            productThumbnail.src = imageUrl;
        }
    });
}

// page name: custom-product-cart.liquid, des: to update variant price by changing on click on variant size
function updateVariant_theme_1(t, productId, variantId, price, compareat, image, title, is_variant_avail) {

    if (is_variant_avail == "true") {
        $(t).parents('.dev_product').find('.dev_hide_if_novar').text("ADD TO CART");
        $(t).parents('.dev_product').find('.dev_disable_if_novar').prop('disabled', false);
    } else {
        $(t).parents('.dev_product').find('.dev_hide_if_novar').text("SOLD OUT");
        $(t).parents('.dev_product').find('.dev_disable_if_novar').prop('disabled', true);
    }

    const variantButtons = $(t).parent('.parent-variant-display').find(`.variant-button-${productId}`);
    $(t).parents('.card-product-print').find('.dev_atc_form').find(`#hidden-variant-${productId}`).val(variantId);

    // Format price to remove '.00' if present
    let formattedPrice = price.includes('.00') ? price.split('.00')[0] : price;
    let formattedCompareAtPrice = compareat.includes('.00') ? compareat.split('.00')[0] : compareat;

    $(t).parents('.dev_product').find('.money-print').html('<span class="non-bold">₹</span>' + formattedPrice);
    $(t).parents('.dev_product').find('.compare-at-price').html('<span class="non-bold">₹</span>' + formattedCompareAtPrice);
    var comp = parseFloat(formattedCompareAtPrice);
    var original = parseFloat(formattedPrice);
    var percentage = ((comp - original) / comp) * 100;
    var roundedPercentage = Math.floor(percentage);


    $(t).parents('.dev_product').find('.percent-off-price').html('(' + roundedPercentage + '% OFF)');

    console.log("money-div", $(t).parents('.max-parent-variant').next('.money-div').find('.money-print').html('<span class="non-bold">₹</span>' + formattedPrice));

    if (!image.includes('no-image')) {
        const imageElement = $(`#product-image-${productId}`);
        imageElement.attr('src', image);
    }

    // Reset styling only for variant buttons within the same product container
    variantButtons.each(function () {
        $(this).css({
            'backgroundColor': '#fff',
            'color': 'black',
            'border': '1px solid black'
        });
    });

    // Change style of clicked button
    $(t).css({
        'backgroundColor': 'white',
        'color': '#FF40B1',
        'border': '1px solid #FF40B1'
    });

    const addToCartButton = $(document).find('.dev_data-att');
    addToCartButton.attr('data-product-id', variantId);
    addToCartButton.attr('data-product-title', title);
    addToCartButton.attr('data-product-price', price);

}

function handleOptioncardClick_theme_1(button, optionName, optionValue, productId, variantId, variantImage, variantPrice, variant_for_inventory, dnk_atc_title) {
    // Remove active class from all buttons in the group
    const buttons = document.querySelectorAll(`.variant-button-${productId}`);
    buttons.forEach(btn => btn.classList.remove('v_active'));

    // Add active class to the clicked button
    button.classList.add('v_active');

    // Update product thumbnail image with selected variant's image
    updateThumbnailImage(productId, variantImage);


    // Update the variant ID input for all sections with the same productId
    const variantButtons = $(button).parent('.parent-variant-display').find(`.variant-button-${productId}`);
    $(button).parents('.card-product-print').find('.dev_atc_form').find(`#hidden-variant-${productId}`).val(variantId);


    // Update the swatch title for the specific card
    $(button).closest('.max-parent-variant').find('.swatch-title-card').text(optionValue);

    // Update the price for the specific variant
    const moneyPrint = $(button).closest('.card-product-new-design').find('.money-print');
    if (moneyPrint.length) {
        moneyPrint.html(`<span class="non-bold vvvv">₹ </span>${variantPrice}`);
    } else {
        console.warn('money-print not found relative to the button');
    }

}

// custom product card variant popup
function openVarientPriceModal_theme_1(variantId) {
    const $modal = $('#openVarientPriceModal-' + variantId);
    const $triggerDiv = event.currentTarget;
    const $icon = $($triggerDiv).find('.icon-caret');

    // Close all other modals
    $('.custom-price-popup-content').fadeOut();
    $('.icon-caret').removeClass('rotated');

    // If the modal is already visible, don't show again
    if ($modal.is(':visible')) {
        $modal.fadeOut();
        $icon.removeClass('rotated');
        return;
    }

    // Show the clicked modal
    $modal.fadeIn();
    $icon.addClass('rotated');

    // Only bind close events once
    if (!$modal.data('initialized')) {
        // Close modal on clicking close button
        $modal.find('.close').on('click', function () {
            $modal.fadeOut();
            $icon.removeClass('rotated');
        });

        // Close modal if clicking outside content
        $(window).on('click', function (event) {
            if ($(event.target).is($modal)) {
                $modal.fadeOut();
                $icon.removeClass('rotated');
            }
        });

        $modal.data('initialized', true);
    }
}

// page name: custom-product-cart.liquid, des: to update variant price by changing on click on variant size
// Handle variant button click to update active state, image, price, and variant ID input
function handleOptioncardClick_theme_2(button, optionName, optionValue, productId, variantId, variantImage, variantPrice, variant_for_inventory, dnk_atc_title) {
    // Remove active class from all buttons in the group
    const buttons = document.querySelectorAll(`.variant-button-${productId}`);
    buttons.forEach(btn => btn.classList.remove('v_active'));

    // Add active class to the clicked button
    button.classList.add('v_active');

    // Update product thumbnail image with selected variant's image
    updateThumbnailImage(productId, variantImage);


    // Update the variant ID input for all sections with the same productId
    // const variantInputs = document.querySelectorAll(`.max-parent-variant-${productId} .product-variant-id`);
    // variantInputs.forEach(input => input.value = variantId);
    const variantButtons = $(button).parent('.parent-variant-display').find(`.variant-button-${productId}`);
    $(button).parents('.card-product-print').find('.dev_atc_form').find(`#hidden-variant-${productId}`).val(variantId);

    // Update the swatch title for the specific card
    $(button).closest('.max-parent-variant').find('.swatch-title-card').text(optionValue);

    // Update the price for the specific variant
    const moneyPrint = $(button).closest('.card-product-new-design').find('.money-print');
    if (moneyPrint.length) {
        moneyPrint.html(`<span class="non-bold vvvv">₹ </span>${variantPrice}`);
    } else {
        console.warn('money-print not found relative to the button');
    }
}

// page name: custom-product-cart.liquid, des: to update variant price by changing on click on variant size
function updateVariant_them_2(t, productId, variantId, price, compareat, image, title, is_variant_avail, inventory_quantity, atc_text) {

    // new code for selecting varient
    // new code - changes ATC button text - depending inventory_quantity
    let customATCText = atc_text; // Get metafield title if available
    let inventoryQuantity = parseInt(inventory_quantity); // convert number string format to integer format 

    if (inventoryQuantity === 0 || inventoryQuantity < 0) {
        $(t).parents('.dev_product').find('.quick-add__submit span:last').text("SOLD OUT");
        $(t).parents('.dev_product').find('.quick-add__submit').prop('disabled', true);
    } else {
        $(t).parents('.dev_product')
            .find('.quick-add__submit span:last')
            .html('<img src="https://cdn.shopify.com/s/files/1/0361/8553/8692/files/Group_52c57d76-b124-4c67-ab95-20735d8df2f4.png?v=1751195664" alt="cart icon" style="width: 17px; height: 17px; display: inline-block;">ADD');
        $(t).parents('.dev_product').find('.quick-add__submit').prop('disabled', false);
    }

    
    const variantButtons = $(t).parent('.parent-variant-display').find(`.variant-button-${productId}`);
    $(t).parents('.card-product-print').find('.dev_atc_form').find(`#hidden-variant-${productId}`).val(variantId);

    // Format price to remove '.00' if present
    let formattedPrice = price.includes('.00') ? price.split('.00')[0] : price;
    let formattedCompareAtPrice = compareat.includes('.00') ? compareat.split('.00')[0] : compareat;

    $(t).parents('.dev_product').find('.money-print').html('<span class="non-bold">₹</span>' + formattedPrice);
    $(t).parents('.dev_product').find('.compare-at-price').html('<span class="non-bold">₹</span>' + formattedCompareAtPrice);
    var comp = parseFloat(formattedCompareAtPrice);
    var original = parseFloat(formattedPrice);
    var percentage = ((comp - original) / comp) * 100;
    var roundedPercentage = Math.floor(percentage);


    $(t).parents('.dev_product').find('.percent-off-price').html('(' + roundedPercentage + '% OFF)');

    //console.log("money-div", $(t).parents('.max-parent-variant').next('.money-div').find('.money-print').html('<span class="non-bold">₹</span>' + formattedPrice));

    if (!image.includes('no-image')) {
        const imageElement = $(`#product-image-${productId}`);
        imageElement.attr('src', image);
    }

    // Reset styling only for variant buttons within the same product container
    variantButtons.each(function () {
        $(this).css({

            'backgroundColor': '#fff',
            'color': '#000',
            'border': '1px solid #000'
        });
    });

    // Change style of clicked button
    $(t).css({

        'backgroundColor': '#ffffff',
        'color': '#ff40b1',
        'border': '2px solid #ff40b1'
    });

    const addToCartButton = $(document).find('.dev_data-att');
    addToCartButton.attr('data-product-id', variantId);
    addToCartButton.attr('data-product-title', title);
    addToCartButton.attr('data-product-price', price);
}